export default "__VITE_ASSET__mAjMbSpx__"